import {
  FormWrapper,
  FormGroup,
  Form
} from "../../../../components/CustomForm/FormStyles";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import Colors from "../../../../themes/Colors";
import useEmpresa from "../../../../hooks/useEmpresa";
import { DATE_FORMATS } from "../../../../utils/Constant";
import moment from "moment";
import PropTypes from "prop-types";

const PrecertificacionGenerales = (props) => {
  const { precertificacion } = props;
  const empresa = useEmpresa();
  return (
    <>
      <Section>
        <FormWrapper borderColor={Colors.transparent}>
          <Form>
            <FormGroup>
              <CustomInput
                readonly={true}
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Fecha"}
                isLabelWithContainer={true}
                value={moment(precertificacion?.fecha).format(
                  DATE_FORMATS.slash
                )}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                label={"Tipo Solicitud"}
                isLabelWithContainer={true}
                value={precertificacion?.tipoSolicitud}
                readOnly={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Teléfono PSS"}
                isLabelWithContainer={true}
                value={precertificacion?.telefono}
                readOnly={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Correo Electrónico PSS"}
                isLabelWithContainer={true}
                value={precertificacion?.correo}
                readOnly={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Médico Prescriptor"}
                isLabelWithContainer={true}
                value={precertificacion?.medicoPrescriptor}
                readOnly={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Diagnóstico"}
                isLabelWithContainer={true}
                value={precertificacion?.diagnostico}
                readOnly={true}
              />
            </FormGroup>

            <FormGroup width={"98%"}>
              <CustomInput
                height={"60px"}
                font={empresa?.LETRA_PRINCIPAL}
                placeholder={"Comentarios"}
                type={"text"}
                value={precertificacion?.comentarios}
                readOnly={true}
              />
            </FormGroup>
          </Form>
        </FormWrapper>
      </Section>
    </>
  );
};

PrecertificacionGenerales.propTypes = {
  precertificacion: PropTypes.shape({
    nombreAsegurado: PropTypes.string,
    descripcionPlan: PropTypes.string,
    numeroPlastico: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cedula: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fecha: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.instanceOf(Date)
    ]),
    tipoSolicitudDescripcion: PropTypes.string,
    telefono: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    correo: PropTypes.string,
    medicoPrescriptor: PropTypes.string,
    diagnostico: PropTypes.string,
    comentarios: PropTypes.string
  })
};

export default PrecertificacionGenerales;
